module.exports = __webpack_public_path__ + "45328d8635367c215b7a2786f0da6aa0.png";


//////////////////
// WEBPACK FOOTER
// ./components/sign-up-modal/src/img/profile-collage.png
// module id = 2414
// module chunks = 0